import React, { useMemo } from 'react';
import { Box, Inscription, LargeCloseIcon } from '@common-fe/common-fe';

import { EllipsisText } from '../MultipleServicesSelector.styles';

const MIN_SHOWN_SERVICES = 3;

interface Props {
  onClear: () => void;
  setIsShown: () => void;
  items: string[];
}

const FakeInput: React.FC<Props> = ({ items, onClear, setIsShown }) => {
  const minServicesText = useMemo(() => items.slice(0, MIN_SHOWN_SERVICES).join(', '), [items]);

  return (
    <Box
      data-testId="fake_search_input"
      width="320px"
      height="40px"
      border={{ size: 'medium', color: 'border1' }}
      round="8px"
      justify="between"
      align="center"
      pad={{ left: 'spacing16', right: 'spacing8' }}
      direction="row"
    >
      <Box direction="row" onClick={setIsShown} data-testId="fake_search_input_set_shown">
        <EllipsisText
          title={minServicesText}
          color="textBody"
          lineHeight="20px">
          {minServicesText}
        </EllipsisText>
        {items.length - MIN_SHOWN_SERVICES > 0 ? (
          <Inscription color="textAccent" lineHeight="20px">
            +{items.length - MIN_SHOWN_SERVICES}
          </Inscription>
        ) : null}
      </Box>
      <Box data-testId="fake_search_input_set_clear" onClick={onClear} width={{ min: '24px' }}>
        <LargeCloseIcon
          color="iconPrimary"
          style={{ background: 'canvas', cursor: 'pointer' }}
        />
      </Box>
    </Box>
  );
};

export default FakeInput;
